import {
	DROP_UPLOAD_KEYS_FORM_MODULE_ID,
	PREVIEW_BRAND_REWARDS_MODAL_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import dropUploadKeys from 'root/src/client/logic/tableItem/thunks/dropUploadKeys'
import dropUploadKeysOnSuccess	from 'root/src/client/logic/tableItem/thunks/dropUploadKeysOnSuccess'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'
import { readFileAsText } from 'root/src/shared/util/readFileAsText'

export default {
	[DROP_UPLOAD_KEYS_FORM_MODULE_ID]: [
		{
			action: formData => async (dispatch, getState) => {
				const formFile = formData?.csvKeys?.file

				if (!formFile) {
					throw { csvKeys: 'Keys file is required' }
				}

				const fileOutput = await readFileAsText(formFile)

				const keysArray = fileOutput.split('\n')

				return new Promise((resolve, reject) => dispatch(
					displayModal(
						PREVIEW_BRAND_REWARDS_MODAL_MODULE_ID, {
							rewards: keysArray,
							onSubmit: () => resolve(dropUploadKeys(formData)(dispatch, getState)),
							// eslint-disable-next-line prefer-promise-reject-errors
							onClose: () => reject({ csvKeys: 'Keys were not added' }),
						},
					),
				))
			},
			onSuccess: dropUploadKeysOnSuccess,
		},
	],
}
